import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/shared/config';
import { getPasswordLength } from '@/shared/lib/password';
import { ErrorText } from '@/shared/ui';

import styles from './CustomPasswordError.module.scss';

type CustomPasswordErrorProps = {
  className?: string;
  inputValue: string;
  minLength?: number;
};

export const CustomPasswordError: FC<CustomPasswordErrorProps> = ({
  className,
  inputValue,
  minLength = MIN_PASSWORD_LENGTH,
}) => {
  const { formatMessage } = useIntl();

  const passwordLength = getPasswordLength(inputValue ?? '');

  return (
    <div
      className={cn(styles.container, className)}
      data-component="custom-password-error"
    >
      <ErrorText
        className="p1"
        withInput
        error={formatMessage({
          id: 'finishRegistration.password.errorTitle',
          defaultMessage: 'A strong password adheres to the following rules:',
        })}
      />
      <ul className={styles.rules}>
        <li className={cn(passwordLength >= minLength && styles.passed)}>
          <ErrorText
            error={formatMessage(
              {
                id: 'finishRegistration.password.minLengthError',
                defaultMessage: 'At least {count} characters',
              },
              { count: minLength },
            )}
          />
        </li>
        <li
          className={cn(passwordLength <= MAX_PASSWORD_LENGTH && styles.passed)}
        >
          <ErrorText
            error={formatMessage(
              {
                id: 'finishRegistration.password.maxLengthError',
                defaultMessage: 'At most {count} characters',
              },
              { count: MAX_PASSWORD_LENGTH },
            )}
          />
        </li>
      </ul>
    </div>
  );
};
